import { Center, Image, Spinner, Text } from '@chakra-ui/react';

import useFetchSavingsImageUrl from 'app/hooks/useFetchSavingsImageUrl';

interface SavingPotImageProps {
  imageId?: string;
  name: string;
  variant?: 'THUMBNAIL';
  h: string;
}

function SavingPotImage({
  imageId = undefined,
  name,
  variant = undefined,
  h,
}: SavingPotImageProps) {
  const { data: imageUrl, isInitialLoading } = useFetchSavingsImageUrl(imageId, variant);

  return (
    <Center w="full" h={h} bg="brand.lightGray2" overflow="hidden" flexShrink={0}>
      {isInitialLoading && <Spinner size="sm" color="brand.purple" />}
      {!isInitialLoading && imageUrl && (
        <Image
          src={imageUrl}
          alt={name}
          objectFit="cover"
          w="full"
          h="full"
          loading="lazy"
          decoding="async"
        />
      )}
      {!isInitialLoading && !imageUrl && (
        <Text textStyle="extraSmallRegular" color="brand.darkGray">
          No image
        </Text>
      )}
    </Center>
  );
}

export default SavingPotImage;
